import React from 'react';

import Menu from '../../components/menu';
import Content from './content';
import Main from './main';

import './style.css';

class Home extends React.Component {
  componentDidMount() {
    window.scrollTo({
      left: 0,
      top: 1
    });
  }
  render() {
    return (
      <>
        <Menu key="menu" />
        <Main />
        <Content key="content" />
      </>
    );
  }
}

export default Home;
